import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type OrganizeProps = {
    className?: string;
};

const Organize: FunctionComponent<OrganizeProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'organize'}
            viewBox="0 0 250 250"
        >
            <path d="M249.8 244.5H0v-179h249.8v179zM9 235.5h231.8v-161H9v161z" />
            <polygon points="20 35 225.5 35 225.5 44 20 44" />
            <polygon points="44 6 206.8 6 206.8 15 44 15" />
        </svg>
    );
};
export default Organize;
